export enum ColumnTypes {
    ATTRIBUTE = 'name',
    DATA_TYPE = 'fieldTypes',
    EVENT_CODES = 'eventCodes',
}

export const COLUMN_CAPTIONS = {
    [ColumnTypes.ATTRIBUTE]: 'Attribute',
    [ColumnTypes.DATA_TYPE]: 'Data Types',
    [ColumnTypes.EVENT_CODES]: 'Event Codes',
};

export const ColumnWidth = {
    [ColumnTypes.ATTRIBUTE]: '20rem',
    [ColumnTypes.DATA_TYPE]: '15rem',
    [ColumnTypes.EVENT_CODES]: 'calc(100% - 35rem)',
};
